export const magasinheader = [
    {
        "ordre": 1,
        "champ": "magasin.mag_nom",
        "label_champ": "Magasin",
        "format_champ": "",
        "affiche_tableau": true,
        "align": "",
        "add_only": false,
        "modif": false
    },
    {
        "ordre": 2,
        "champ": "nombre_vise",
        "label_champ": "Vise",
        "format_champ": "",
        "affiche_tableau": true,
        "align": "",
        "add_only": false,
        "modif": false
    },
    {
        "ordre": 3,
        "champ": "nombre_reel",
        "label_champ": "Reel",
        "format_champ": "",
        "affiche_tableau": true,
        "align": "",
        "add_only": false,
        "modif": false
    }
]